export function getUrlValue(fieldName) {
  const urlParams = new URLSearchParams(window.location.search);                
  const value = decodeURIComponent(urlParams.get(fieldName));
  return value === 'null' ? undefined : value;
}

export function getUrlValues(fieldNames) {
  const urlParams = new URLSearchParams(window.location.search);
  let retVal = {};
  fieldNames.forEach(name => {
    if (urlParams.get(name)) {
      retVal[name] = decodeURIComponent(urlParams.get(name));
    }
  });
  return retVal;
}

export function hasAllFieldNames(object, fieldNames) {
  let retVal = true;
  fieldNames.forEach(name => {
    if (!object[name]) {
      retVal = false
    }
  });
  return retVal;
}

export function getMissingUrlValuesFromObject(object, fieldNames) {
  const urlParams = new URLSearchParams(window.location.search);
  let retVal = {};
  fieldNames.forEach(name => {
    if (object[name] && !urlParams.get(name)) {
      retVal[name] = object[name]
    }
  });
  return retVal;
}
